import {Editor} from "@tiptap/core";
import { DceJsxRenderer } from "dce-jsx";
import {Transaction} from "prosemirror-state";

export abstract class ToolbarItem extends DceJsxRenderer {

    abstract mount(editor: Editor): void;

    abstract consumeTransaction(editor: Editor, transaction: Transaction): void;

}